export default {
  serviceInfoURL: 'https://demo.datasafe.dev/reg/service/info',
  appId: 'hds-lib-tests',
  modelURL: 'https://model.datasafe.dev/pack.json'
};
